import { render, staticRenderFns } from "./hue-bar.vue?vue&type=template&id=2646b7e2&"
import script from "./hue-bar.vue?vue&type=script&lang=js&"
export * from "./hue-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports